import { Elements } from "@stripe/react-stripe-js"
import { loadStripe, Stripe } from "@stripe/stripe-js"
import { ConfigProvider } from "antd"
import { useContext, useEffect, useState } from "react"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import styled, { ThemeProvider, useTheme } from "styled-components"
import { CustomerRoot, ErrorBoundary, Footer, Routewk } from "./components"
import { STRIPE_PUBLIC_KEY } from "./config"
import { UserContext, UserProvider } from "./context"
import { MenuProvider } from "./context/MenuContext"
import { adminRoutes, generalRoutes, userRoutes } from "./routes"
import { isAdmin } from "./utils/userUtils"

import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { App as AntdApp } from "antd"
import { Mirror360Theme } from "./context/theme"
// import styles from "./less/global.less"

let stripePromise: Promise<Stripe | null> | null = null
try{
    if (STRIPE_PUBLIC_KEY && STRIPE_PUBLIC_KEY.length > 0) {
        stripePromise = loadStripe(STRIPE_PUBLIC_KEY)
    }
}catch(err){
    console.error('Stripe initialization error:', err)
    stripePromise = null
}

const MainContent = styled.div`
  background-color: ${(props) => props.theme.white};
  min-height: 90vh;
`

const queryClient = new QueryClient()

export default function App(): JSX.Element {
  return (
     <ErrorBoundary>
    <AntdApp>
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined"
      />
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <QueryClientProvider client={queryClient}>
          <UserProvider>
            <MenuProvider>
              {stripePromise ? (
                <Elements stripe={stripePromise}>
                  <ThemeProvider theme={Mirror360Theme}>
                    <MainPage />
                  </ThemeProvider>
                </Elements>
              ) : (
                <ThemeProvider theme={Mirror360Theme}>
                  <MainPage />
                </ThemeProvider>
              )}
            </MenuProvider>
          </UserProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </AntdApp>
    </ErrorBoundary>
  )
}

function MainPage(): JSX.Element {
  const [globalFontSize, setGlobalFontSize] = useState<number>(16)
  const user = useContext(UserContext)
  useEffect(() => {
    // consolelog('change font size',)
    if (isAdmin(user.user)) {
      setGlobalFontSize(16) //should change to 14 when ready
    } else {
      setGlobalFontSize(16)
    }
  }, [user.user?.userRole, user.user])
  const theme = useTheme()

  return (
    <ConfigProvider
      theme={{

        token: {
          fontSize: globalFontSize,
          // colorText:theme.primary,
          colorPrimary: theme.primary,
          colorText: "black",
          // colorSplit:'rgba(5,5,5,1)',
        },
        components: {
          Button: {
            primaryShadow: theme.primary,
          },
          Steps: {
            navArrowColor: theme.primary,
          },          
          Menu:{
            itemSelectedColor:'white',
            itemSelectedBg:theme.secondary,
            
            subMenuItemSelectedColor:theme.primary,            
          }
        },
      }}
    >
      <MainContent>
        <Routes>
          {/* note: the routes are not fully used, antd tabs nullifed the necessity of most of them */}
          <Route path="/" element={<CustomerRoot />}>
            {[
              ...generalRoutes,
              ...adminRoutes, //admin router should be above user routes, as myspace/* catch all should be below specific routes in the admin routes
              ...userRoutes,              
            ].map((x) => Routewk(x))}
          </Route>
        </Routes>
      </MainContent>
      <Footer />
    </ConfigProvider>
  )
}
